import * as THREE from 'three';
import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js';
import { MeshSurfaceSampler } from 'three/examples/jsm/math/MeshSurfaceSampler.js';
import {
	Brush,
	Evaluator,
	ADDITION,
	SUBTRACTION,
	REVERSE_SUBTRACTION,
	INTERSECTION,
	DIFFERENCE,
	HOLLOW_SUBTRACTION,
	HOLLOW_INTERSECTION,
    computeMeshVolume,
} from 'three-bvh-csg';
import { reactStates } from '../../../context/filecontext';
import { loadGltfCustom } from '../../../utils/loaders/gltfLoader/gltfLoaderCustom';


export async function complexCSG(inParams) {

    let {scene, designLasUrl: glb1, actualLasUrl: glb2} = inParams;
    const params = {

        operation: SUBTRACTION,
        wireframe: false,
        displayBrushes: false,
        shadows: true,
        useGroups: true,
        consolidateGroups: true,
    
        randomize: () => {
    
            randomizeBrushes();
            updateCSG();
    
        }
    };

    let scope = {
        doOperation: updateCSG,
        properties: params,
    };

    let gui;
    let bunnyBrush, brushes;
    let material, surfaceSampler;
    let resultObject 
     let light;
    let csgEvaluator = new Evaluator();
    csgEvaluator.attributes = [ 'position', 'normal' ];
    csgEvaluator.useGroups = false;
    
    const materialMap = new Map();
    
    return await init();
    
    async function init() {
    
        // lights
        light = new THREE.DirectionalLight( 0xffffff, 3.5 );
        light.position.set( 1, 2, 1 );
        scene.add( light, new THREE.AmbientLight( 0xb0bec5, 0.35 ) );
    
        // shadows
        const shadowCam = light.shadow.camera;
        light.castShadow = true;
        light.shadow.mapSize.setScalar( 4096 );
        light.shadow.bias = 1e-5;
        light.shadow.normalBias = 1e-2;
    
        shadowCam.left = shadowCam.bottom = - 2.5;
        shadowCam.right = shadowCam.top = 2.5;
        shadowCam.updateProjectionMatrix();
    
        // camera setup
        // camera.position.set( 0, 0.65, 2.5 );
        // camera.updateProjectionMatrix();
    
        await reactStates.current.showLoader("Processing Design Model");
        // scope.gltf = await new GLTFLoader()

        // // .setMeshoptDecoder( MeshoptDecoder )
        // // .loadAsync( 'https://raw.githubusercontent.com/gkjohnson/3d-demo-data/main/models/stanford-bunny/bunny.glb' );
        // // .loadAsync( 'http://localhost:3000/assets/three/glb/actual_mesh.glb' );
        // .loadAsync( glb1 );

        scope.gltf = await loadGltfCustom(glb1)
        
        await reactStates.current.showLoader("Processing Actual Model");

        // scope.gltf2 = await new GLTFLoader()
        // // .setMeshoptDecoder( MeshoptDecoder )
        // // .loadAsync( 'https://raw.githubusercontent.com/gkjohnson/3d-demo-data/main/models/stanford-bunny/bunny.glb' );
        //     // .loadAsync( 'http://localhost:3000/assets/three/glb/design_mesh.glb' );
        //     .loadAsync( glb2 );
        scope.gltf2 = await loadGltfCustom(glb2)

        // let gltf ={scene: new THREE.Mesh( new THREE.BoxGeometry(2,2,2,32,32,32), new THREE.MeshBasicMaterial({color:"red"}) )}
        // let gltf2 ={scene: new THREE.Mesh( new THREE.BoxGeometry(1,1,1,32,32,32), new THREE.MeshBasicMaterial({color:"green"}) )}


        let s1 = scope.gltf.scene;
        let s2 = scope.gltf2.scene
        s1.creator = "csg"
        s2.creator = "csg"

        let m1 = scope.gltf.scene.children[0]
        let m2 = scope.gltf2.scene.children[0]
        // let m1 = s1
        // let m2 = s2
        let bBox = new THREE.Box3().setFromObject(m1);
        const geometry = m1.geometry.clone();
        const geometry2 = m2.geometry.clone();

        geometry.computeVertexNormals();
        geometry2.computeVertexNormals();
    
        // initialize brushes
        bunnyBrush = new Brush( geometry, new THREE.MeshStandardMaterial() );
        // bunnyBrush.position.y = - 0.5;
        bunnyBrush.updateMatrixWorld();
        bunnyBrush.receiveShadow = true;
        // scene.add( bunnyBrush );
    
        material = new THREE.MeshStandardMaterial();
        brushes = [];
    
        surfaceSampler = new MeshSurfaceSampler( bunnyBrush );
        surfaceSampler.build();
    
        for ( let i = 0; i < 1; i ++ ) {
            const b = new Brush( geometry2, material );
            b.updateMatrixWorld();
            b.receiveShadow = true;
            brushes.push( b );
        }
    
        // initialize materials
        // bunnyBrush.material.opacity = 0.15;
        // bunnyBrush.material.transparent = true;
        // bunnyBrush.material.depthWrite = false;
        // bunnyBrush.material.polygonOffset = true;
        // bunnyBrush.material.polygonOffsetFactor = 0.1;
        // bunnyBrush.material.polygonOffsetUnits = 0.1;
        // bunnyBrush.material.side = THREE.DoubleSide;
        // bunnyBrush.material.premultipliedAlpha = true;
        // bunnyBrush.material.color.set( 0xE0F7FA );
    
        // material.opacity = 0.15;
        // material.transparent = true;
        // material.depthWrite = false;
        // material.polygonOffset = true;
        // material.polygonOffsetFactor = 0.1;
        // material.polygonOffsetUnits = 0.1;
        // material.side = THREE.DoubleSide;
        // material.premultipliedAlpha = true;
        // material.roughness = 0.25;
        // material.color.set( 0x4DD0E1 );
    
        // create solid material equivalents
        let mat;
        mat = bunnyBrush.material.clone();
        mat.opacity = 1;
        mat.transparent = false;
        mat.depthWrite = true;
        materialMap.set( bunnyBrush.material, mat );
    
        mat = material.clone();
        mat.opacity = 1;
        mat.transparent = false;
        mat.depthWrite = true;
        materialMap.set( material, mat );
    
        // add object displaying the result
        resultObject = new THREE.Mesh( new THREE.BufferGeometry(), new THREE.MeshStandardMaterial( {
            roughness: 0.1,
            flatShading: false,
            polygonOffset: true,
            polygonOffsetUnits: 1,
            polygonOffsetFactor: 1,
            opacity: 1,
        } ) );
        resultObject.castShadow = false;
        resultObject.receiveShadow = false;
        resultObject.name = "resultObject"
        // scene.add( resultObject );
    
        // add wireframe representation
        scope.wireframeResult = new THREE.Mesh( resultObject.geometry, new THREE.MeshBasicMaterial( {
            wireframe: true,
            color: 0,
            opacity: 0.15,
            transparent: true,
        } ) );
        scope.wireframeResult.material.color.set( 0x001516 );
        // scene.add( wireframeResult );
    
        // getGUI();
        // randomizeBrushes();
        // updateCSG();
        // render();

        return scope
    
    }
    
    function getGUI() {
        gui = new GUI();
        gui.add(params, 'operation', {
            ADDITION, SUBTRACTION, REVERSE_SUBTRACTION, INTERSECTION,
            DIFFERENCE, HOLLOW_SUBTRACTION, HOLLOW_INTERSECTION,
        }).onChange(() => {

            updateCSG();

        });
        gui.add(params, 'displayBrushes');
        gui.add(params, 'shadows');
        gui.add(params, 'wireframe');
        gui.add(params, 'useGroups').onChange(updateCSG);
        gui.add(params, 'consolidateGroups').onChange(updateCSG);
        gui.add(params, 'randomize');
    }

    function updateCSG(r,operation) {
        let resultObject = r 
        const startTime = window.performance.now();
        let finalBrush = brushes[ 0 ];
        csgEvaluator.useGroups = params.useGroups;
        csgEvaluator.consolidateGroups = params.consolidateGroups;
        for ( let i = 1, l = brushes.length; i < l; i ++ ) {
    
            const b = brushes[ i ];
            finalBrush = csgEvaluator.evaluate( finalBrush, b, ADDITION );
            // finalBrush.material = material;
    
        }
    
        csgEvaluator.evaluate( bunnyBrush, finalBrush, operation, r );
        if ( params.useGroups ) {
    
            // resultObject.material = resultObject.material.map( m => materialMap.get( m ) );
    
        } else {
    
            // resultObject.material = materialMap.get( bunnyBrush.material );
    
        }

        resultObject.visible = true;
    
        const deltaTime = window.performance.now() - startTime;
        let bBox = new THREE.Box3()
        bBox.setFromObject(resultObject)
        let width = bBox.max.x - bBox.min.x;
        let height = bBox.max.y - bBox.min.y;
        let depth = bBox.max.z - bBox.min.z;
        let volume = computeMeshVolume(resultObject);
        console.log(volume,"volume")
        return {
            volume : volume,
            output : r
        }

    }
    
    function randomizeBrushes() {
    
        for ( let i = 0; i < brushes.length; i ++ ) {
    
            const b = brushes[ i ];
            surfaceSampler.sample( b.position );
            b.position.applyMatrix4( bunnyBrush.matrixWorld );
            b.scale.setScalar( THREE.MathUtils.lerp( 0.05, 0.15, Math.random() ) );
            b.updateMatrixWorld();
    
        }
    
    }
    
    function render() {
        return 
        requestAnimationFrame( render );
    
        scope.wireframeResult.visible = params.wireframe;
        bunnyBrush.visible = params.displayBrushes;
        brushes.forEach( b => b.visible = params.displayBrushes );
    
        light.castShadow = params.shadows;
    
    
    }

}





